import ProgrammingContainer from './programming_container';

const Programming = ProgrammingContainer;
export default Programming;
